module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joanne Rock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('I', [_vm._v("USA TODAY")]), _vm._v(" bestselling author Joanne Rock credits her decision to write romance to a book she picked up during a flight delay that engrossed her so thoroughly, she didn't mind at all when her flight was delayed two more times. Giving her readers the chance to escape into another world has motivated her to write over one hundred books for a variety of Harlequin series. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PQSnAt/tc-custom/9781488062759.jpg?1705201833722",
      "alt": "This image is the cover for the book Heartbreaker, Dynasties: Mesa Falls"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Heartbreaker, Dynasties: Mesa Falls\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From passion to betrayal and back again! USA TODAY bestselling author Joanne Rock welcomes you to Mesa Falls, where family loyalties and passions collide… Dive into this dramatic Dynasties romance!  He knows she’s coming for him… and he’s ready to turn the tables!  When tabloid columnist Elena Rollins shows up uninvited to a private, star-studded party at Mesa Falls, Gage Striker sees red. Though it’s been six years since their abrupt breakup, the scars—and attraction—are still fresh. Certain his ex has a score to settle, the playboy banker vows to protect his ranch’s scandalous secrets. Protecting his heart is a different story.  From Harlequin Desire: Luxury, scandal, desire—welcome to the lives of the American elite.  Dynasties: Mesa Falls: Book 1: The Rebel Book 2: The Rival Book 2: Rule Breaker Book 4: Heartbreaker Book 5: The Rancher Book 6: The Heir")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0